var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightDirec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3877_1240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3877_1240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74808 5.88126L5.41346 2.54664L6.2925 1.6676L11.1278 6.50292L6.2925 11.3383L5.41346 10.4592L8.74808 7.12459H1.18115V5.88126H8.74808Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3877_1240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.19,
    height: 11.19,
    fill: "white",
    transform: "translate(0.560059 0.909973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3877_1240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.19,
    height: 11.19,
    fill: "white",
    transform: "translate(0.560059 0.909973)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDirec);
export default __webpack_public_path__ + "static/media/right-direc.3e1da8a29c019a86de09e3307d4521db.svg";
export { ForwardRef as ReactComponent };